<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<style scoped>
#app {
  @apply h-screen w-full;
}

:deep(
    .el-button--primary,
    .el-button--primary:hover,
    .el-button--primary:focus,
    .el-button--primary:active,
    .el-button--primary.is-plain,
    .el-button--primary.is-disabled,
    .el-button--primary:not(.is-disabled):hover,
    .el-button--primary:not(.is-disabled).is-active
  ) {
  background: linear-gradient(to bottom right, var(--primary-color), var(--secondary-color)) !important;
  border-color: transparent !important;
  border: none !important;
  border-color: transparent !important;

  /* Remove default box shadow or focus outlines */
  box-shadow: none !important;
  outline: none !important;

  /* Make sure the gradient is continuous to the edges */
  background-clip: padding-box;
  transition: filter 0.2s ease;
}

:deep(.el-button--primary:not(.is-disabled):hover) {
  filter: brightness(0.9); /* Darken on hover */
}

:deep(.el-button--primary:not(.is-disabled):active) {
  filter: brightness(0.7); /* Even darker when clicked */
}

:deep(
    .el-button--danger,
    .el-button--danger:hover,
    .el-button--danger:focus,
    .el-button--danger:active,
    .el-button--danger.is-plain,
    .el-button--danger.is-disabled,
    .el-button--danger:not(.is-disabled):hover,
    .el-button--danger:not(.is-disabled).is-active
  ) {
  background-color: var(--danger-color) !important;
  color: white !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  background-clip: padding-box;
  transition: background-color 0.2s ease;
}

:deep(.el-button--danger:hover) {
  background-color: #711414 !important; /* Tailwind's red-800 */
  animation: shake 0.3s ease-in-out;
}

@keyframes shake {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-2px);
  }
  50% {
    transform: translateX(2px);
  }
  75% {
    transform: translateX(-2px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
